import { useGlobalQuery } from '@/state/query-client/hooks';
import { getHolidayCantons } from '../services/holiday-lookups.service';

/** Cantons of the active organization; idle until `enabled` (the canton-based box is ticked). */
export const useGetHolidayCantons = (enabled = true) => {
  return useGlobalQuery({
    queryKey: ['hr-holiday-cantons'],
    queryFn: () => getHolidayCantons(),
    enabled,
    staleTime: 30 * 60 * 1000,
  });
};
